import React from 'react';

import { IVendorPromotion } from '@models/VendorVariant/i-vendor-variant';

import styles from './VendorPromotion.module.scss';

export interface IVendorPromotionProps {
  vendorVariant: {
    vendorPromotion?: IVendorPromotion;
    vendorTieredDiscountCode?: {
      discountTerms?: string|null;
    };
  };
  className?: string;
}

const VendorPromotion = ({
  vendorVariant,
  className = undefined
}: IVendorPromotionProps) => {
  const { vendorPromotion, vendorTieredDiscountCode } = vendorVariant;

  const promoText = vendorTieredDiscountCode?.discountTerms || vendorPromotion?.promoText;

  if (!promoText) return null;

  return (
    <div data-test="vendor-promotion" className={className}>
      <div className={`${styles['m-vendor-promotion']} position-relative d-inline-block`}>
        <span
          className={styles[`m-vendor-promotion__promo-text`]}
          data-test="vendor-promotion_text"
        >
          {promoText}
        </span>

        <a
          className={`${styles['m-vendor-promotion__more-button']} d-inline-block pl-2`}
          href="/current-promotions"
          target="_blank"
        >
          Details
        </a>
      </div>
    </div>
  );
};

export default VendorPromotion;
